<template>
  <Listbox v-model="selected" :disabled="disabled">
    <div class="relative w-full drop-down">
      <ListboxButton
        class="w-full px-3 py-2 border border-argus-border rounded-lg bg-white hover:border-rentapp-primary-gray"
        :class="[error ? 'border-rentapp-status-red' : '']"
      >
        <div class="flex justify-between">
          <div class="flex text-left max-w-4/5">
            <span class="text-left text-sm text-argus-forest-800 truncate overflow-ellipsis">{{
              selected ? selected.label : initial ? initial.label : placeholder
            }}</span>
          </div>
          <div class="flex flex-row-reverse items-center">
            <ChevronDownIcon class="w-5 h-5 text-argus-forest-600" />
          </div>
        </div>
      </ListboxButton>

      <transition
        leave-active-class="transition duration-100 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <ListboxOptions
          class="absolute w-full py-2 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-40 md:max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-10"
          :class="[dropDownSize]"
        >
          <slot name="option">
            <ListboxOption
              v-slot="{ active }"
              v-for="(item, idx) in options"
              :key="item.label"
              :value="item"
              as="template"
            >
              <li
                class="max-w-full w-full px-2 cursor-pointer"
                :class="[
                  active ? 'text-white bg-argus-emerald-500' : 'text-argus-forest-800',
                  'cursor-default select-none relative py-2 hover:bg-argus-emerald-500 group',
                ]"
              >
                <span
                  class="flex mx-auto text-sm text-argus-forest-800"
                  :class="[active ? 'text-white' : 'group-hover:text-white']"
                  :ref="`list-option-${idx}`"
                  >{{ item.label }}</span
                >
              </li>
            </ListboxOption>
          </slot>
        </ListboxOptions>
      </transition>
    </div>
  </Listbox>
</template>
<script>
import { Listbox, ListboxButton, ListboxOptions, ListboxOption } from '@headlessui/vue'

import { ChevronDownIcon } from '@heroicons/vue/24/outline'

export default {
  components: {
    Listbox,
    ListboxButton,
    ListboxOptions,
    ListboxOption,
    ChevronDownIcon,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    initial: {
      type: Object,
      default: null,
    },
    placeholder: {
      type: String,
      default: 'Select',
    },
    showSelectedAsGray: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dropDownSize: {
      type: String,
      default: 'h-40',
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {},
  data() {
    return {
      selected: null,
    }
  },
  watch: {
    initial: {
      handler(val) {
        if (val) {
          this.selected = val
        }
      },
      immediate: true,
      deep: true,
    },
    selected(val, oldVal) {
      if (!oldVal && this.initial && val.value === this.initial.value) {
        return
      }
      this.$emit('select', val)
    },
  },
  methods: {},
}
</script>
<style scoped>
/* @keyframes moveText {
  100% {
    transform: translateX(-50%);
  }
}

.slide-text {
  animation: moveText 10s linear infinite;
} */
</style>
